import clsx from 'clsx'

import { Icon, type IconName } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import { ShipperTooltip } from '../../components/ShipperTooltip'
import {
  type BolNumberAvailabilityState,
  useBolNumAvailability,
} from './useBolNumAvailability'

type Props = {
  bolNumber: string
  loadId?: string
}

const availabilityHints: Record<BolNumberAvailabilityState, string> = {
  available: 'BOL# is available',
  used: 'This BOL# is already used on another shipment',
  loading: 'Checking BOL# availability…',
  idle: '',
}

const availabilityIcons: Record<BolNumberAvailabilityState, IconName | null> = {
  available: 'check-circle',
  used: 'exclamation-triangle',
  loading: 'spinner',
  idle: null,
}

const availabilityClassNames: Record<BolNumberAvailabilityState, string> = {
  available: 'text-fv-green-bright',
  used: 'text-fv-orange-bright',
  loading: 'text-fv-gray-dark',
  idle: '',
}

export const BolNumAvailabilityAdornment = ({
  bolNumber,
  loadId,
  className,
}: PropsWithClassName<Props>) => {
  const availability = useBolNumAvailability(bolNumber, loadId)
  const icon = availabilityIcons[availability]

  if (!icon) {
    return null
  }

  return (
    <ShipperTooltip label={availabilityHints[availability]}>
      <Icon
        icon={icon}
        className={clsx(availabilityClassNames[availability], className)}
      />
    </ShipperTooltip>
  )
}
